// To be deleted once api is ready

export const incidents = [
  {
    first_fired: '2019-08-06T21:00:00.000Z',
    last_fired: null,
    status: 'Resovled',
    triggered_value: 30,
    filters: {},
    assignment: 'Message Bird.'
  },
  {
    first_fired: '2019-08-06T21:00:00.000Z',
    last_fired: '2019-08-06T21:00:00.000Z',
    status: 'Resolved',
    triggered_value: 30,
    filters: {
      subaccount_id: 3,
      mailbox_provider: 'gmail',
      sending_ip: '1.1.1.1'
    },
    assignment: 'Sparky’s Cookie Co.'
  },
  {
    first_fired: '2019-08-06T21:00:00.000Z',
    last_fired: '2019-08-06T21:00:00.000Z',
    status: 'Open',
    triggered_value: 30,
    filters: {
      subaccount_id: 3,
      mailbox_provider: 'gmail',
      sending_ip: '1.1.1.1'
    },
    assignment: 'Sparky’s Cookie Co.'
  },
  {
    first_fired: '2019-08-06T21:00:00.000Z',
    last_fired: '2019-08-06T21:00:00.000Z',
    status: 'Open',
    triggered_value: 30,
    filters: {
      subaccount_id: 3,
      mailbox_provider: 'gmail',
      sending_ip: '1.1.1.1'
    },
    assignment: 'Sparky’s Cookie Co.'
  },
  {
    first_fired: '2019-08-06T21:00:00.000Z',
    last_fired: '2019-08-06T21:00:00.000Z',
    status: 'Open',
    triggered_value: 30,
    filters: {
      subaccount_id: 3,
      mailbox_provider: 'gmail',
      sending_ip: '1.1.1.1'
    },
    assignment: 'Sparky’s Cookie Co.'
  },
  {
    first_fired: '2019-08-06T21:00:00.000Z',
    last_fired: '2019-08-06T21:00:00.000Z',
    status: 'Open',
    triggered_value: 30,
    filters: {
      subaccount_id: 3,
      mailbox_provider: 'gmail',
      sending_ip: '1.1.1.1'
    },
    assignment: 'Sparky’s Cookie Co.'
  },
  {
    first_fired: '2019-08-06T21:00:00.000Z',
    last_fired: '2019-08-06T21:00:00.000Z',
    status: 'Open',
    triggered_value: 30,
    filters: {
      subaccount_id: 3,
      mailbox_provider: 'gmail',
      sending_ip: '1.1.1.1'
    },
    assignment: 'Sparky’s Cookie Co.'
  },
  {
    first_fired: '2019-08-06T21:00:00.000Z',
    last_fired: '2019-08-06T21:00:00.000Z',
    status: 'Open',
    triggered_value: 30,
    filters: {
      subaccount_id: 3,
      mailbox_provider: 'gmail',
      sending_ip: '1.1.1.1'
    },
    assignment: 'Sparky’s Cookie Co.'
  },
  {
    first_fired: '2019-08-06T21:00:00.000Z',
    last_fired: '2019-08-06T21:00:00.000Z',
    status: 'Open',
    triggered_value: 30,
    filters: {
      subaccount_id: 3,
      mailbox_provider: 'gmail',
      sending_ip: '1.1.1.1'
    },
    assignment: 'Sparky’s Cookie Co.'
  },
  {
    first_fired: '2019-08-06T21:00:00.000Z',
    last_fired: '2019-08-06T21:00:00.000Z',
    status: 'Open',
    triggered_value: 30,
    filters: {
      subaccount_id: 3,
      mailbox_provider: 'gmail',
      sending_ip: '1.1.1.1'
    },
    assignment: 'Sparky’s Cookie Co.'
  },
  {
    first_fired: '2019-08-06T21:00:00.000Z',
    last_fired: '2019-08-06T21:00:00.000Z',
    status: 'Open',
    triggered_value: 30,
    filters: {
      subaccount_id: 3,
      mailbox_provider: 'gmail',
      sending_ip: '1.1.1.1'
    },
    assignment: 'Sparky’s Cookie Co.'
  },
  {
    first_fired: '2019-08-06T21:00:00.000Z',
    last_fired: '2019-08-06T21:00:00.000Z',
    status: 'Open',
    triggered_value: 30,
    filters: {
      subaccount_id: 3,
      mailbox_provider: 'gmail',
      sending_ip: '1.1.1.1'
    },
    assignment: 'Sparky’s Cookie Co.'
  },
  {
    first_fired: '2019-08-06T21:00:00.000Z',
    last_fired: '2019-08-06T21:00:00.000Z',
    status: 'Open',
    triggered_value: 30,
    filters: {
      subaccount_id: 3,
      mailbox_provider: 'gmail',
      sending_ip: '1.1.1.1'
    },
    assignment: 'Sparky’s Cookie Co.'
  },
  {
    first_fired: '2019-08-06T21:00:00.000Z',
    last_fired: '2019-08-06T21:00:00.000Z',
    status: 'Open',
    triggered_value: 30,
    filters: {
      subaccount_id: 3,
      mailbox_provider: 'gmail',
      sending_ip: '1.1.1.1'
    },
    assignment: 'Sparky’s Cookie Co.'
  },
  {
    first_fired: '2019-08-06T21:00:00.000Z',
    last_fired: '2019-08-06T21:00:00.000Z',
    status: 'Open',
    triggered_value: 30,
    filters: {
      subaccount_id: 3,
      mailbox_provider: 'gmail',
      sending_ip: '1.1.1.1'
    },
    assignment: 'Sparky’s Cookie Co.'
  },
  {
    first_fired: '2019-08-06T21:00:00.000Z',
    last_fired: '2019-08-06T21:00:00.000Z',
    status: 'Open',
    triggered_value: 30,
    filters: {
      subaccount_id: 3,
      mailbox_provider: 'gmail',
      sending_ip: '1.1.1.1'
    },
    assignment: 'Sparky’s Cookie Co.'
  },
  {
    first_fired: '2019-08-06T21:00:00.000Z',
    last_fired: '2019-08-06T21:00:00.000Z',
    status: 'Open',
    triggered_value: 30,
    filters: {
      subaccount_id: 3,
      mailbox_provider: 'gmail',
      sending_ip: '1.1.1.1'
    },
    assignment: 'Sparky’s Cookie Co.'
  }
];

export const alert = {
  name: 'My Alert Name',
  metric: 'health_score',
  channels: {
    emails: ['Myemail@email.com', 'email@ddress.com'],
    slack: { target: 'https://hooks.slack.com/services/X' },
    webhook: { target: 'target.com/200' }
  },
  threshold_evaluator: { source: 'raw', operator: 'lt', value: 80 },
  subaccounts: [-1],
  any_subaccount: false,
  muted: false,
  severity: 'High',
  first_incident_fired: '2019-08-06T21:00:00.000Z',
  last_incident_fired: '2019-08-06T21:00:00.000Z',
  notifications: 'Enabled',
  condition: 'above',
  precision: 'hour',
  filters: [{ AND: { subaccounts: { eq: [{ id: 209, type: 'subaccounts', value: 209 }] } } }],
  assignment: 'primary',
  days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
  timeframe: {
    from: '11am',
    to: '13pm',
    timezone: '(UTC-04:00) America/New York'
  }
};
